module.exports = __webpack_public_path__ + "static/media/homepage_grid_2.561b51ca.jpg";